import { WarrantyObject } from "interfaces/warranty-interfaces";

export const extractWarrantyList = (
  payload: { data?: Record<string, unknown> }
): { list: WarrantyObject[]; total: number } => {
  const root = (payload?.data ?? {}) as Record<string, unknown>;
  const data = root.data ?? root;

  if (Array.isArray(data)) {
    return { list: data as WarrantyObject[], total: data.length };
  }

  const nested = data as { results?: WarrantyObject[]; totalResults?: number };
  if (Array.isArray(nested?.results)) {
    return {
      list: nested.results,
      total: nested.totalResults ?? nested.results.length,
    };
  }

  if (Array.isArray(root.listEntityClass)) {
    const list = root.listEntityClass as WarrantyObject[];
    return {
      list,
      total: (root.records as number) ?? list.length,
    };
  }

  return { list: [], total: 0 };
};
